theme.announcement = (function () {
  function announcementModule(element) {
    const announcement = {
      open: document.getElementById("announcement-more-info"),
      close: document.querySelector(".close__announcement--bar"),
      wrapper: document.querySelector(".announcement-collapsible-content"),
    };

    // Hide the announcement bar
    const hide = () => {
      announcement.wrapper.classList.remove("open");
      announcement.open.classList.remove("show--dropdown");
      slideUp(announcement.wrapper);
    };

    // open the announcement bar
    const open = () => {
      announcement.wrapper.classList.add("open");
      announcement.open.classList.add("show--dropdown");
      slideDown(announcement.wrapper);
    };

    // Click open event
    announcement.open?.addEventListener("click", (event) => {
      event.preventDefault();
      let isOpen = announcement.wrapper.classList.contains("open")
        ? true
        : false;
      if (isOpen) {
        hide();
      } else {
        open();
      }
    });

    // Click close event
    announcement.close?.addEventListener("click", (event) => {
      event.preventDefault();
      hide();
    });
  }
  return announcementModule;
})();

class announmentBar extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.onRemoveAnnouncement);
  }
  onRemoveAnnouncement(event) {
    let evtTargetElement = event.target;
    if (evtTargetElement.classList.contains("announcement--timer-close-btn")) {
      evtTargetElement.closest(".announcement-bar").remove();
    }
  }
}
customElements.define("announcement-bar", announmentBar);

document.addEventListener("DOMContentLoaded", function () {
  const input = document.querySelector("#annoucement");
  const animated = document.querySelector("#annoucementanimated");

  if (!input  || !animated ) return;

  const placeholders = [
    "Discover the Essence of B REAL Silver",
    "Made With Love",
    "100% Transarency in our products!",
    "Welcome To B Real Silver."
  
  ];

  let index = 0;
  animated.textContent = placeholders[index];

  function rotatePlaceholder() {
    animated.classList.remove("spin-in");
    animated.classList.add("spin-out");

    setTimeout(() => {
      index = (index + 1) % placeholders.length;
      animated.textContent = placeholders[index];
      animated.classList.remove("spin-out");
      animated.classList.add("spin-in");
    }, 300);
  }

  setInterval(rotatePlaceholder, 2500);

  // Hide animated placeholder when user types
  input.addEventListener("input", () => {
    animated.style.display = input.value.length ? "none" : "block";
  });
});
